import processClient from '.'
import { getAuthHeaders } from 'utils/requests'
import { cacheClear } from 'utils/memoryCache'

const atributeProcess = async (id, userName, userId) => {
  const headers = { headers: getAuthHeaders() }
  const response = await processClient.patch(
    `/save/${id}`,
    { ResponsavelNome: userName, ResponsavelId: userId },
    headers
  )
  cacheClear('processes:')
  return response
}

export default atributeProcess

